import React from 'react';
import DataDrivenArticlePage from '../components/articles/DataDrivenArticlePage';

const FunctionalSafetyProcessTechnicalArticlePage = () => (
  <DataDrivenArticlePage slug="article-functional-safety-process" pdfSlug="functional-safety-process" />
);

export default FunctionalSafetyProcessTechnicalArticlePage;
